import { z } from "zod";

/** A 64-bit Steam ID as a 17-digit string, as Steam sign-in returns it. */
export const SteamId = z.string().regex(/^7656\d{13}$/, "Not a Steam ID");

export const Me = z.object({
  id: z.string().uuid(),
  steamId: SteamId,
  name: z.string(),
  avatarUrl: z.string().url().nullable(),
});
export type Me = z.infer<typeof Me>;

/** What the web app gets from GET /api/me. */
export const MeResponse = z.object({
  user: Me.nullable(),
  /** True when the server allows the development sign-in (never in production). */
  devSignIn: z.boolean(),
  /** True for the players who manage who may sign in (ADMIN_STEAM_IDS). */
  isAdmin: z.boolean(),
});
export type MeResponse = z.infer<typeof MeResponse>;
